









































import {Component, Vue, Prop} from 'vue-property-decorator';
import {CardForm} from '@/components/bwaff';
import { SecuritylApi } from '@/views/settings/security/api';

@Component({
  components: {
    CardForm,
  }
})
export default class SecondFactor extends Vue {
  @Prop() 
  api: SecuritylApi;

  enable() {
    this.bus.emit('open-dialog', { name: 'EnableSecondFactor' });
  }

  disable() {
    this.bus.emit('open-dialog', { name: 'DisableSecondFactor' });
  }

}
